module.exports = __webpack_public_path__ + "static/cool-pug-095806438dec509999eaba29174e659e.jpg";